import React, { useContext } from "react";
import { FilterContext } from "../filters-context";
import useMediaQuery from "@mui/material/useMediaQuery";

const SyndicatFilter = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const onSyndicatClick = () => {
    if (filters.openedFilter === "syndicat") {
      setOpenedFilter(null);
    } else {
      setOpenedFilter("syndicat");
    }
  };
  const selectSyndicat = (syndicat) => {
    setSyndicat(syndicat);
  };

  const handleChange = (event) => {
    const syndicat = guideFilters.syndicat.find((syndicat) => {
      return Number(event.target.value) === syndicat.id;
    });
    setSyndicat(syndicat);
  };
  const { filters, setSyndicat, setOpenedFilter } = useContext(FilterContext);
  return (
    <>
      {guideFilters &&
        guideFilters.syndicat &&
        guideFilters.syndicat.length > 0 && (
          <div
            className={`filter-container ${
              filters.openedFilter === "syndicat" ? "is-open" : ""
            }`}
          >
            <button
              className={`filter-button ${
                filters.syndicat && filters.syndicat.label ? "is-selected" : ""
              }`}
              onClick={() => {
                onSyndicatClick();
              }}
            >
              {filters.syndicat && filters.syndicat.label
                ? filters.syndicat.label
                : "Filtrer par syndicat adhérent"}
            </button>
            {isMobile ? (
              <select
                name="syndicat-select"
                onChange={handleChange}
                value={filters.syndicat?.id || ""}
              >
                <option value={""}>Tous les syndicats</option>
                {guideFilters.syndicat.map((syndicat) => {
                  return (
                    <option key={syndicat.id} value={syndicat.id}>
                      {syndicat.label}
                    </option>
                  );
                })}
              </select>
            ) : (
              <ul className="filter-list">
                {filters.syndicat && filters.syndicat.label && (
                  <li>
                    <button
                      onClick={() => {
                        selectSyndicat(null);
                      }}
                    >
                      Tous les syndicats
                    </button>
                  </li>
                )}
                {guideFilters.syndicat.map((syndicat) => (
                  <li key={syndicat.id}>
                    <button
                      onClick={() => {
                        selectSyndicat(syndicat);
                      }}
                    >
                      {syndicat.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
    </>
  );
};

export default SyndicatFilter;
